export function capitalizeFirstLetter<T extends string | null | undefined>(
  word: T
): T {
  if (!word) return word;
  return (word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) as T;
}
export default capitalizeFirstLetter;
